<script>
	// Componentes Svelte
	import { Router, Link, link , Route } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';
	
	let itens = [{}];

	let fichas = [
		{
			name: 'Pessoa Física - Locatário ou Fiador',
			link: 'CadastroPF_LocatarioFiador.pdf',
		},
		{
			name: 'Pessoa Jurídica - Locatário ou Fiador',
			link: 'CadastroPJ_LocatarioFiador.pdf',
		}
	];
</script>

<section class="fichas-cadastrais">
	<PageHeader title="Fichas Cadastrais"></PageHeader>
	<div class="container">
		<p class="text-justify">Para efetuar seu cadastro, baixe o arquivo correspondente ao seu perfil, preencha, assine e entregue na imobiliária.</p>
		<div class="grid grid-size--1">
			{#each fichas as ficha}
				<div class="button">
					<a class="btn btn-secondary" href="/assets/files/{ficha.link}" target="_blank" title="Clique aqui para Baixar a Ficha para {ficha.name}">
						<i class="far fa-download"></i> {ficha.name}
					</a>
				</div>
			{/each}
		</div>
	</div>
</section>

<style type="text/scss">
@import 'public/assets/sass/variables.sass';

.fichas-cadastrais .itens{
	margin-top: 30px;
	.item{
		min-width: 200px;
		h2{
			margin-top: 10px;
			font-size: $font-text;
			text-transform: uppercase;
			font-weight: bold;
			color: $color-primary;
			white-space: normal;
		}
	}
}

</style>